module.exports = __webpack_public_path__ + "img/16_windAndRain_zyl.4c74c385.png";